const getBadgeVariantForHealthStatus = (status?: string) => {
    switch ((status ?? '').toLowerCase()) {
        case 'healthy':
            return 'success' as const;
        case 'stable':
            return 'default' as const;
        case 'at_risk':
            return 'warning' as const;
        case 'critical':
            return 'error' as const;
        default:
            return 'default' as const;
    }
};

export default getBadgeVariantForHealthStatus;
